import { observer } from 'mobx-react';
import React from 'react';
import { Switch } from 'react-router-dom';
import { SCREENS } from 'src/constants/screens';
import { appStore } from 'src/mobx/appStore';
import { localeStore } from 'src/mobx/localesStore';
import CustomRoute from 'src/view/components/CustomRoute/CustomRoute';
import LoginScreen from 'src/view/screens/LoginScreen/LoginScreen';

@observer
class PublicRouter extends React.Component<{}, {}> {
  public render() {
    if (!appStore.settings || !localeStore.localizationLoaded) return null;

    return (
      <Switch>
        <CustomRoute exact permissions={[]} path={[SCREENS.REST()]} component={LoginScreen} />
      </Switch>
    );
  }
}

export default PublicRouter;
